import { CalendarAccountOutlineIcon } from './CalendarAccountOutlineIcon';

/**
 * author: Michael Richins
 * id B852A287-2C5E-4468-9A83-6B5E0ABD1219
 * name calendar-account-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-account-outline.svg
 * tags
 * - Date / Time 
 * - Account / User 
 */
export const CalendarUserOutlineIcon = CalendarAccountOutlineIcon;
export default CalendarUserOutlineIcon